import { jsx as _jsx } from "react/jsx-runtime";
import { Badge as BootstrapBadge } from 'react-bootstrap';
import styles from './Badge.module.scss';
const Badge = ({ variant = 'primary', pill = false, children, className = '' }) => {
    return (_jsx(BootstrapBadge, { bg: variant, pill: pill, className: `${styles.badge} ${className}`, children: children }));
};
export default Badge;
